import { useEffect, useState } from "react";
import DynamicEditForm from "../DynamicEditForm";
import ModalError from "../Modal/ModalError";
import ModalLoading from "../Modal/ModalLoading";
import MapEditorDetailsView from './MapEditorDetailsView';
import { useGetPlotByLotQuery } from "/src/redux/plotsApi";
import {useUpdatePlotMutation} from '/src/redux/plotsApi';
import useQueryEffect from "/src/hooks/useQueryEffect";

const formConfig = {
    autoFocus: true,
    saveText: 'Search',
    hideDiscard: true,
    hideRequiredHint: true,
    fields: [
        {
            key: '_lotId',
            title: 'Lot',
            type: 'lotId',
            required: true,
        },
    ]
}

export default function MapEditorLotSearch({onSuccess, lng, lat}){
    const [error, setError] = useState(null);
    const [formInput, setFormInput] = useState({});
    const [searchReq, setSearchReq] = useState(null);
    const { data: found, error: searchError, isLoading: isSearching } = useGetPlotByLotQuery(searchReq, {skip: !searchReq});
    const [updatePlot, { error: updateError, isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdatePlotMutation();

    const userTookAction = useQueryEffect(error=>{
        if(error){
            setError(error);
        }else{
            if(onSuccess) onSuccess(found && found._id);
            reset();
        }
    },[isUpdateSuccess],[updateError]);
    
    useEffect(()=>{
        if(searchError) setError(searchError.data);
    },[searchError])

    function onSearch(data){
        setSearchReq(data._lotId);
    }
    function reset(){
        setFormInput({});
        setSearchReq(null);
        setError(null);
    }
    function onConfirmMatch(_id){
        // trigger mutation to add lat and lng to existing plot
        userTookAction();
        updatePlot({
            _id,
            lat,
            lng,
        });
    }
    
    return (
        <div>
            {(isSearching || isUpdating) && <ModalLoading absolute={true} title={isUpdating?"Saving":"Searching"} />}
            {error && <ModalError message={error.message} callback={()=>setError(null)} />}
            {(found && searchReq && (
                <div>
                    <p className="text-xl">Found a matching entry:</p>
                    <MapEditorDetailsView _id={found._id} />
                    <div className="border border-yellow-600 p-4 mt-4">
                        <p className="font-bold mb-2">Does this look correct?</p>
                        <div className='flex group'>
                            <button onClick={()=>onConfirmMatch(found._id)} className="btn group-hover:btn-invert">Yes, use these details</button>
                            <button onClick={()=>reset()} className="btn-invert">Cancel</button>
                        </div>
                    </div>
                </div>
            )) || (
                <DynamicEditForm formConfig={formConfig} selectedAsset={formInput} onSave={data=>onSearch(data)} />
            )}
        </div>
    )
}